import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import type { DateCalculationType } from "../utilities/dateCalculationTypes";
import { dateCalculationTypes, getDateCalculationCaption } from "../utilities/dateCalculationTypes";

interface Props {
  selectedType: DateCalculationType | undefined;
  onSelectedTypeChange: (type: DateCalculationType) => void;
  readonly: boolean;
}

const DateTypeSelect = ({ selectedType, onSelectedTypeChange, readonly }: Props) => {
  return (
    <FormControl>
      <InputLabel id="date-calculation-type-label">Type</InputLabel>
      <Select
        labelId="date-calculation-type-label"
        label="Type"
        value={selectedType ?? ""}
        onChange={(evt) => onSelectedTypeChange(evt.target.value as DateCalculationType)}
        disabled={readonly}
      >
        {dateCalculationTypes.map((type) => (
          <MenuItem key={type} value={type}>
            {getDateCalculationCaption(type)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DateTypeSelect;
